import React from "react";
import Layout from "./layout/Layout";
import About from "./pages/about/About";
import CertifiedDiamonds from "./pages/certifiedDiamonds/CertifiedDimonds";
import Home from "./pages/home/Home";
import Blogs from "./pages/blogs/Blogs";
import BlogDetail from "./pages/blogs/BlogDetail";
import Contact from "./pages/contact/Contact";
import Events from "./pages/events/Events";
import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/login/login";
import DiamonDetails from "./pages/dimondDetails/DiamonDetails";
import UserProfile from "./pages/profile/UserProfile";
import ForgetPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndCondition from "./pages/TermsAndCondition";
import Jck from "./pages/jck/Jck";
import ProtectedWrapper from "./components/auth/ProtectedWrapper";
import PageNotfound from "./pages/PageNotfound";
import EditProfile from "./pages/profile/EditProfile";
import EditProfileTab from "./pages/profile/EditProfileTab";

export const routes = [
  {
    path: "/",
    element: <Layout />, // acts as a layout
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "certified-diamonds",
        element: <CertifiedDiamonds />,
      },
      {
        path: "certified-dimond/:id",
        element: <DiamonDetails />,
      },
      {
        path: "blog",
        element: <Blogs />,
      },
      {
        path: "blog/:slug",
        element: <BlogDetail />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "events",
        element: <Events />,
      },
      {
        path: "sign-up",
        element: <Signup />,
      },

      {
        path: "profile",
        element: (
          <ProtectedWrapper>
            <UserProfile />
          </ProtectedWrapper>
        ),
      },
      {
        path: "profile/edit",
        element: (
          <ProtectedWrapper>
            <EditProfileTab />
          </ProtectedWrapper>
        ),
      },
      {
        path: "forget-password",
        element: <ForgetPassword />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "terms-and-condition",
        element: <TermsAndCondition />,
      },
      // {
      //   path: "jck",
      //   element: <Jck />,
      // },
      {
        path: "login",
        element: <Login />,
      },
      {
        path: "*",
        element: <PageNotfound />,
      },
    ],
  },
];
